var extractFieldId = function extractFieldId(fieldStr) {
  return fieldStr.substring(8, fieldStr.length - 2);
};

var extractContextId = function extractContextId(contextStr) {
  return contextStr.substring(1, contextStr.length - 1);
};

export default {
  extractFieldId: extractFieldId,
  extractContextId: extractContextId
};